
export default {
    arrow_left: "tabler:arrow-left",
    android: "logos:google-play-icon",
    angleRight: "uil:angle-right",
    angleLeft: "uim:angle-left",
    angleDoubleRight: "uis:angle-double-right",
    angleDoubleLeft: "uil:angle-double-left",
    arrowLongRight: "gg:arrow-right",
    arrowLongLeft: "gg:arrow-left",
    arrowLongUp: "gg:arrow-up",
    arrowLongDown: "gg:arrow-down",
    arrowRightUp: "mingcute:arrow-right-up-line",
    arrowLeftDown: "mingcute:arrow-left-down-line",
    account_suspend: "mdi:account-cancel-outline",

    bank: "streamline-freehand:saving-bank",
    bill: "solar:bill-check-broken",

    cancel: "iconoir:cancel",
    check: "gg:check",
    create: "uil:create-dashboard",
    cog: "clarity:cog-line",
    compose: "fluent:compose-24-filled",
    copy: "mynaui:copy",

    dashboard: "humbleicons:dashboard",
    delete: "solar:trash-bin-2-linear",
    dot: "mdi:dot",

    edit: "fluent:edit-24-regular",
    email: "ic:outline-email",
    eye: "solar:eye-linear",

    gaming_pad: "famicons:game-controller-outline",
    gaming_pad_spark: "streamline:ai-gaming-spark",

    items: "carbon:microservices-1",
    ios: "tdesign:logo-apple-filled",

    message: "tabler:message-2",

    naira: "mdi:naira",
    survey: "fluent:notepad-person-24-regular",
    notification: "solar:bell-broken",

    pencil: "fluent:edit-24-regular",
    phone: "solar:phone-outline",
    phone_hand: "material-symbols-light:lift-to-talk",
    phone_credit_card: "streamline-freehand:credit-card-phone-call",

    refresh: "material-symbols:refresh",
    result: "stash:search-results",

    smartphone_wifi: "hugeicons:smartphone-wifi",
    suspend: "tabler:cancel",

    task: "mdi:task-auto",
    history: "hugeicons:transaction-history",

    user: "ep:user",
    // user_cancel: "mdi:user-cancel-outline",
    user_cancel: "tabler:user-cancel",

    watch_video: "streamline-ultimate:movie-cinema-watch",
    watch_video_mobile: "mdi:book-play-outline",

    // Social Icons
    facebook: "logos:facebook",
    instagram: "skill-icons:instagram",
    linkedin: "skill-icons:linkedin",
    tiktok: "logos:tiktok-icon",
    x: "prime:twitter",

}